// extracted by mini-css-extract-plugin
module.exports = {"officeDetails":"OfficeDetails_officeDetails__sJpYe","wide":"OfficeDetails_wide__7b5_f","addressPoster":"OfficeDetails_addressPoster__bSw6W"};